<section class="delete-card-modal">
  <div class="modal-header">
    <div class='modal-close' (click)='close()'>
      <!-- SVG for close button -->
      <svg xmlns="http://www.w3.org/2000/svg" width='16' height='16'
           viewBox="0 0 16 16">
        <defs>
          <style>.cls-1 {
            fill: #707373;
          }

          .cls-2 {
            fill: none;
          }</style>
        </defs>
        <g>
          <g>
            <rect class="cls-1" x="4" y="4" width="1" height="1"></rect>
            <rect class="cls-1" x="3" y="3" width="1" height="1"></rect>
            <rect class="cls-1" x="5" y="5" width="1" height="1"></rect>
            <rect class="cls-1" x="6" y="6" width="1" height="1"></rect>
            <rect class="cls-1" x="7" y="7" width="1" height="1"></rect>
            <rect class="cls-1" x="7" y="7" width="1" height="1"></rect>
            <rect class="cls-1" x="8" y="8" width="1" height="1"></rect>
            <rect class="cls-1" x="9" y="9" width="1" height="1"></rect>
            <rect class="cls-1" x="10" y="10" width="1" height="1"></rect>
            <rect class="cls-1" x="11" y="11" width="1" height="1"></rect>
            <rect class="cls-1" x="12" y="12" width="1" height="1"></rect>
            <rect class="cls-1" x="4" y="11" width="1" height="1" transform="translate(-7 16) rotate(-90)"></rect>
            <rect class="cls-1" x="3" y="12" width="1" height="1" transform="translate(-9 16) rotate(-90)"></rect>
            <rect class="cls-1" x="5" y="10" width="1" height="1" transform="translate(-5 16) rotate(-90)"></rect>
            <rect class="cls-1" x="6" y="9" width="1" height="1" transform="translate(-3 16) rotate(-90)"></rect>
            <rect class="cls-1" x="7" y="8" width="1" height="1" transform="translate(-1 16) rotate(-90)"></rect>
            <rect class="cls-1" x="7" y="8" width="1" height="1" transform="translate(-1 16) rotate(-90)"></rect>
            <rect class="cls-1" x="8" y="7" width="1" height="1" transform="translate(1 16) rotate(-90)"></rect>
            <rect class="cls-1" x="9" y="6" width="1" height="1" transform="translate(3 16) rotate(-90)"></rect>
            <rect class="cls-1" x="10" y="5" width="1" height="1" transform="translate(5 16) rotate(-90)"></rect>
            <rect class="cls-1" x="11" y="4" width="1" height="1" transform="translate(7 16) rotate(-90)"></rect>
            <rect class="cls-1" x="12" y="3" width="1" height="1" transform="translate(9 16) rotate(-90)"></rect>
            <rect class="cls-2" width="16" height="16"></rect>
          </g>
        </g>
      </svg>
    </div>
  </div>
  <div class="modal-body">
    <p>Потвердите удаление.</p>
    <hr>
    <button class="btn-danger" type="button" (click)="delete()">Удалить</button>
  </div>
</section>
